import APIServiceBase from '@lib/api-services/APIServiceBase'

export default class APIServicesRegistry {

    /** @private */
    static _registry = {};

    /**
     * Adds an instance of {@link APIServiceBase} to the registry.
     *
     * @public
     * @param {string} name
     * @param {UIServiceBase} instance
     */
    static addService(name, instance) {
        APIServicesRegistry._registry[name] = instance
    }

    /**
     * Removes service with given name from the registry.
     *
     * @public
     * @param {string} name
     */
    static removeService(name) {
        delete APIServicesRegistry._registry[name]
    }

    /**
     * Gets an instance of {@link UIServiceBase} registered with given name.
     *
     * @public
     * @param {Class} serviceClass Service to look for.
     * @return {UIServiceBase}
     */
    static getService(serviceClass) {
        return APIServicesRegistry._registry[serviceClass.name]
    }
}

export function registerAPIService(service) {
    $(document).ready(() => {
        let instance = new service()
        APIServicesRegistry.addService(service.name, instance)
    })
}
